import React from "react";
import { Theme } from "@material-ui/core/styles/createMuiTheme";
import createStyles from "@material-ui/core/styles/createStyles";
import withStyles from "@material-ui/core/styles/withStyles";

const styles = (theme: Theme) =>
  createStyles({
    root: {
      padding: theme.spacing(4),
      width: "100%",

      [theme.breakpoints.down("sm")]: {
        padding: theme.spacing(2)
      }
    }
  });

type Props = {
  classes: any;
  children: any;
};

const PageRoot = (props: Props) => {
  const { children, classes } = props;
  return <div className={classes.root}>{children}</div>;
};

const styled = withStyles(styles)(PageRoot);

export { styled as PageRoot };
